const initialState = {
	open: false,
	message: '',
	type: ''
};

export default function alertReducer(state = initialState, action) {
	switch (action.type) {
		case 'ALERT_SUCCESS':
			return {
				type: 'Success',
				message: action.message,
				open: true
			};
		case 'ALERT_ERROR':
			return {
				type: 'Error',
				message: action.message,
				open: true
			};
		case 'ALERT_CLEAR':
			return {
				type: '',
				message: '',
				open: false
			};
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/alertReducer.js